import React, { FunctionComponent } from 'react';
import { Modal } from 'react-bootstrap';
import A11yModal from '../A11yModal';
import CtaButton from '../CtaButton/CtaButton';
import styles from './Dialog.css';
import LoadingOverlay from 'src/components/LoadingOverlay/LoadingOverlay';
import cn from 'classnames';

export interface IDialogProps {
    title: string | React.ReactNode;
    label: string;
    onClose: () => void;
    modalBody: string;
    show: boolean;
    onHide: (event: KeyboardEvent | undefined) => void;
    modalBodyHeading: string;
    isLoading?: boolean;
    className?: string;
    shouldCloseOnOverlayClick?: boolean;
    // New optional prop for rich content
    modalBodyContent?: Array<{
        type: 'text' | 'link';
        value: string;
        color?: string;
        href?: string;
        prefix?: string; // Optional text to render before a link
    }>;

}

const Dialog: FunctionComponent<IDialogProps> = (props) => {
    const {
        title,
        label,
        onClose,
        modalBody,
        show,
        onHide,
        modalBodyHeading,
        isLoading = false,
        className,
        shouldCloseOnOverlayClick,
        modalBodyContent
    } = props;

    return (
        <A11yModal
            size={'sm'}
            show={show}
            onHide={onHide}
            className={cn(styles.dialogModal, className)}
            bodyOpenClassName={styles.confirmationModalContainer}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            <Modal.Header className={styles.modalHeader}>
                <Modal.Title as={'h4'}>{title}</Modal.Title>
            </Modal.Header>
            <LoadingOverlay active={isLoading} className={styles.loading} spinner={isLoading}>
                <Modal.Body className={styles.modalBodyHeading}>
                    <h4>{modalBodyHeading}</h4>
                </Modal.Body>
                <Modal.Body className={styles.modalBody}>
                    {modalBodyContent ? (
                        modalBodyContent.map((item, index) => {
                            if (item.type === 'text') {
                                return (
                                    <p key={index} style={{ color: item.color || 'inherit', whiteSpace: 'pre-line' }}>
                                        {item.value}
                                    </p>
                                );
                            } else if (item.type === 'link') {
                                return (
                                    <p key={index}>
                                        {item.prefix && <span>{item.prefix}</span>}
                                        <a href={item.href} target="_blank" rel="noopener noreferrer">
                                            {item.value}
                                        </a>
                                    </p>
                                );
                            }
                            return null;
                        })
                    ) : (
                        <p>{modalBody}</p>
                    )}
                </Modal.Body>
            </LoadingOverlay>
            <Modal.Footer className={styles.modalFooter}>
                <div>
                    <CtaButton onClick={onClose}>
                        {label}
                    </CtaButton>
                </div>
            </Modal.Footer>
        </A11yModal>
        
    );
};

export default Dialog;